import ControlHubsIcon from "../../assets/product-list-assets/control-hubs.svg";
import type { ProductListGroup } from "../../types";

export const doorAccessControlHubs: ProductListGroup = {
  id: "doorAccessControlHubs",
  title: "productListGroup.controlHubs.title",
  seriesLabel: "modelCompare.seriesLabel.doorAccessControlHubs",
  icon: {
    src: ControlHubsIcon,
    width: 20,
    height: 20,
  },
};
